
























import Vue from 'vue'
import Carousel from '@/common/components/Carousel.vue'
import CategoryCard from '@/search/components/category/CategoryCard.vue'
import { DisplayChildCategory } from '@/common/types/index'

const DESKTOP_BREAKPOINT = 768
const DESKTOP_SLIDES_PER_VIEW = 6

export default Vue.extend({
  components: {
    Carousel,
    CategoryCard
  },
  props: {
    title: {
      type: String,
      required: true
    },
    childCategories: {
      type: Array as () => DisplayChildCategory[],
      required: true
    },
    brandName: {
      type: String,
      default: ''
    }
  },
  computed: {
    isDesktopView(): boolean {
      return window.innerWidth > DESKTOP_BREAKPOINT
    },
    slidesPerView(): number {
      return this.isDesktopView ? DESKTOP_SLIDES_PER_VIEW : 3.5
    },
    slidesPerGroup(): number {
      return this.isDesktopView ? DESKTOP_SLIDES_PER_VIEW : 1
    },
    spaceBetweenSlides(): number {
      return this.isDesktopView ? 32 : 24
    }
  }
})
